/**
 * CalculatorFrame - Metallic chrome calculator border
 *
 * CSS recreation of the retro metallic keypad frame.
 * Structure: outer frame > display recess > divider > button grid recess
 */

import { cn } from '@/lib/utils';

// ============================================
// TYPES
// ============================================

export interface CalculatorFrameProps {
  /** Additional class names */
  className?: string;
  /** Content for display area */
  displayContent?: React.ReactNode;
  /** Content for button grid area */
  buttonContent?: React.ReactNode;
  /** Width of the frame */
  width?: number;
  /** Height of the frame */
  height?: number;
}

// ============================================
// COMPONENT
// ============================================

export function CalculatorFrame({
  className,
  displayContent,
  buttonContent,
  width = 280,
  height = 416,
}: CalculatorFrameProps) {
  return (
    <div
      className={cn('calculator-frame', className)}
      style={{ width, height }}
    >
      {/* Main chrome face - sits on bent edge */}
      <div className="calculator-frame__face" />

      {/* Display wrapper - thin sides */}
      <div className="calculator-frame__display-wrapper">
        <div className="calculator-frame__display">
          {displayContent}
        </div>
      </div>

      {/* Buttons wrapper - thick sides and bottom */}
      <div className="calculator-frame__buttons-wrapper">
        <div className="calculator-frame__buttons">
          {buttonContent}
        </div>
      </div>
    </div>
  );
}
